import PaintbrushIconPath from "@ingka/ssr-icon/paths/paintbrush";

export default PaintbrushIconPath;
